import React from "react";
import { StarIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { testimonials, testimonialsIsDemo } from "../data/testimonials";
const avatarTones = ["bg-royal-light text-royal", "bg-rosy-light text-rosy", "bg-leaf-light text-leaf-deep", "bg-sun-light text-tangerine-dark", "bg-tangerine-light text-tangerine-dark"];
export function TestimonialsSection() {
  return <section className="bg-cream/60" data-id="element-256" data-mp="1d133526drcd7">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-257" data-mp="1d47f4lq37cef">
        {testimonialsIsDemo && <p className="mx-auto mb-6 w-fit rounded-full border-2 border-dashed border-cocoa/30 bg-white px-4 py-1 text-center text-xs font-bold text-cocoa-soft" data-id="element-258" data-mp="1hyuwm0mob6ji">
            Contenu de démonstration — témoignages fictifs à remplacer avant le lancement
          </p>}
        <SectionHeading title="Ces petits moments de foi qui font toute la différence ❤️" subtitle="Des histoires pour transmettre la foi, partager de précieux instants en famille et accompagner les enfants dans leur découverte de Dieu." data-id="element-259" data-mp="2yfpacka11ir7" />

        <ul className="mt-12 flex flex-wrap justify-center gap-6 md:mt-16" data-id="element-260" data-mp="2q39g07xibpaw">
          {testimonials.map((t, i) => <li key={t.name} className="flex w-full flex-col rounded-[1.75rem] bg-white p-6 shadow-[0_6px_24px_rgba(90,58,34,0.08)] md:w-[calc((100%-1.5rem)/2)] md:p-7 lg:w-[calc((100%-3rem)/3)]" data-id="element-261" data-mp="34q2p2vgfnyun" data-mpi={i}>
              <div className="flex gap-0.5" aria-hidden="true" data-id="element-262" data-mp="2c4jjouiihtnl">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-sun text-sun" data-id="element-263" data-mp="2m1fkee265bhl" data-mpi={s} />)}
              </div>
              <blockquote className="mt-4 space-y-3 leading-relaxed text-cocoa" data-id="element-264" data-mp="2h1joz37jesdn">
                {t.paragraphs.map((p, j) => <p key={j} data-id="element-265" data-mp="193zk5u83i8s" data-mpi={j}>
                    {j === 0 && "« "}
                    {p}
                    {j === t.paragraphs.length - 1 && " »"}
                  </p>)}
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-266" data-mp="3gv5o730wamu">
                {t.avatar ? <img src={t.avatar} alt="" className="h-12 w-12 shrink-0 rounded-full object-cover" data-id="element-267" data-mp="8fy9jo79oat8" /> : <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full pt-0.5 font-display text-lg font-bold ${avatarTones[i % avatarTones.length]}`} aria-hidden="true" data-id="element-268" data-mp="i9owuprnqf7c">
                    {initials(t.name)}
                  </span>}
                <div data-id="element-269" data-mp="3vitbmhcqiz4p">
                  <p className="font-display text-lg font-bold leading-tight text-royal-deep" data-id="element-270" data-mp="3vjct5wyh3li7">
                    {t.name}
                  </p>
                  <p className="text-sm text-cocoa-soft" data-id="element-271" data-mp="332a9mr47kpoh">{t.description}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(" ").map(part => part[0]).join("").slice(0, 2);
}